import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/brewcontrol")({
  component: Outlet,
});

/**
 * BrewControl section layout. Deliberately sets no sidebar: fleet-level pages
 * call `useFleetSidebar` themselves and the node layout sets its own layer,
 * so the two never compete for the single sidebar config slot.
 */
